// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subTopicReportTableContainer table{
    border-collapse: collapse;
}

.subTopicReportTableContainer thead tr {
  height: 40px;
}

.subTopicReportTableContainer thead th {
  padding: 5px;
  color: #828282;
}

.subTopicReportTableContainer thead {
  background-color: #f2f2f2;
}

.subTopicReportThCourse {
  width: 5%;
}

.subTopicReportThSubject {
  width: 7%;
}

.subTopicReportThTopic {
  width: 10%;
}

.subTopicReportThObjective {
  width: 8%;
}

.subTopicReportTableContainer tbody tr {
  height: 30px;
  border-bottom: 1px solid #e0e0e0;
}

.subTopicReportTableContainer tbody tr td {
  border-bottom: 1px solid #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Screens/SubTopicReport/SubTopicReportComponents/TableSubTopicRep/tableSubTopicRep.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".subTopicReportTableContainer table{\n    border-collapse: collapse;\n}\n\n.subTopicReportTableContainer thead tr {\n  height: 40px;\n}\n\n.subTopicReportTableContainer thead th {\n  padding: 5px;\n  color: #828282;\n}\n\n.subTopicReportTableContainer thead {\n  background-color: #f2f2f2;\n}\n\n.subTopicReportThCourse {\n  width: 5%;\n}\n\n.subTopicReportThSubject {\n  width: 7%;\n}\n\n.subTopicReportThTopic {\n  width: 10%;\n}\n\n.subTopicReportThObjective {\n  width: 8%;\n}\n\n.subTopicReportTableContainer tbody tr {\n  height: 30px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.subTopicReportTableContainer tbody tr td {\n  border-bottom: 1px solid #e0e0e0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
